import { setLocalStorage, getLocalStorage, isLocalStorageAvailable } from './localStorage';

const updateBetToViewStorage = (bets) => {
    if (isLocalStorageAvailable()) {
        const betToView = getLocalStorage('bet2view') || {};
        const cumulativeStakes = getLocalStorage('cumulativeStakes') || {};
        const bookmaker = bets[0].bets[0].feed.toLowerCase();
        const firstQualification = !Object.prototype.hasOwnProperty.call(
            betToView,
            'qualification',
        );
        const firstAccumulation = !Object.prototype.hasOwnProperty.call(
            cumulativeStakes,
            bookmaker,
        );
        const validStake = 0.01;

        if (firstQualification) {
            betToView.qualification = [];
        }

        if (firstAccumulation) {
            cumulativeStakes[bookmaker] = {};
        }

        for (let i = 0; i < bets.length; i += 1) {
            const { stakePerLine, numberLines } = bets[i];
            const uniqueIds = [];
            let totalStake = stakePerLine * numberLines;

            bets[i].bets.forEach((bet) => {
                const betIsQualified = betToView.qualification.filter(
                    item => (item['race-id'] === bet.raceId && item.bookmaker === bookmaker),
                ).length > 0;

                if (uniqueIds.indexOf(bet.raceId) === -1 && !betIsQualified) {
                    uniqueIds.push(bet.raceId);
                }
            });

            for (let j = 0; j < uniqueIds.length; j += 1) {
                const id = uniqueIds[j];

                if (typeof cumulativeStakes[bookmaker][id] !== 'undefined') {
                    if (totalStake + cumulativeStakes[bookmaker][id] >= validStake) {
                        betToView.qualification.push({
                            bookmaker,
                            'race-id': id,
                        });
                        totalStake = Math.round(
                            ((totalStake + cumulativeStakes[bookmaker][id]) -
                            validStake) * 100) / 100;
                        delete cumulativeStakes[bookmaker][id];
                    } else {
                        cumulativeStakes[bookmaker][id] = Math.round(
                            (cumulativeStakes[bookmaker][id] + totalStake) * 100) / 100;
                        break;
                    }
                } else if (totalStake > 0) {
                    if (totalStake >= validStake) {
                        betToView.qualification.push({
                            bookmaker,
                            'race-id': id,
                        });
                        totalStake = Math.round((totalStake - validStake) * 100) / 100;
                    } else {
                        cumulativeStakes[bookmaker][id] = Math.round(totalStake * 100) / 100;
                        break;
                    }
                }
            }
        }

        setLocalStorage('bet2view', betToView);
        setLocalStorage('cumulativeStakes', cumulativeStakes);

        if (window.bet2viewInitQualification) {
            window.bet2viewInitQualification();
        }
    }
}

export default updateBetToViewStorage;



// WEBPACK FOOTER //
// /src/js/common/utils/betToViewQualification.js